<template>
  <div class="trial-bar">
    <span class="trial-bar__description" style="font-weight: 500;">{{ $t('toaster-messages.latvian_promo') }}</span>
  </div>
</template>

<script setup>
</script>
